;(function () {
  if (typeof window === 'undefined') return

  window.propertyDocumentTags = [
  {
    "documentLabelEN": "sharingDeclaration",
    "documentLabelDE": "Teilungserklärung",
    "additionalDocumentLabel": "",
    "tagCode": "DECLARATION_OF_DIVISION",
    "tagName": "10 Stammdaten/Teilungserklärung",
    "additionalTagName": "",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "managementContract",
    "documentLabelDE": "Verwaltervertrag",
    "additionalDocumentLabel": "",
    "tagCode": "ADMINISTRATOR_AGREEMENT",
    "tagName": "10 Stammdaten/Verwaltervertrag",
    "additionalTagName": "",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "caretaker",
    "documentLabelDE": "Hausmeister",
    "additionalDocumentLabel": "",
    "tagCode": "CONTRACT",
    "tagName": "40 Gebäudedienst/Vertrag",
    "additionalTagName": "40 Gebäudedienst/HausmeisterVertrag",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "cleaning",
    "documentLabelDE": "Gebäudereinigung",
    "additionalDocumentLabel": "",
    "tagCode": "CONTRACT",
    "tagName": "40 Gebäudedienst/Vertrag",
    "additionalTagName": "40 Gebäudedienst/GebäudereinigungVertrag",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "outdoor",
    "documentLabelDE": "Aussenanlage",
    "additionalDocumentLabel": "",
    "tagCode": "OUTDOOR_FACILITIES",
    "tagName": "30 Versorger/Außenanlage",
    "additionalTagName": "",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "winter",
    "documentLabelDE": "Winterdienst",
    "additionalDocumentLabel": "",
    "tagCode": "CONTRACT",
    "tagName": "40 Gebäudedienst/Vertrag",
    "additionalTagName": "40 Gebäudedienst/WinterdienstVertrag",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "heatingMaintenanceContract",
    "documentLabelDE": "Heizung",
    "additionalDocumentLabel": "",
    "tagCode": "HEATING_SANITARY",
    "tagName": "30 Versorger/Heizung+Sanitär",
    "additionalTagName": "30 Versorger/Heizung",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "energyCertificate",
    "documentLabelDE": "Energieausweis",
    "additionalDocumentLabel": "",
    "tagCode": "ENERGY_CERTIFICATE",
    "tagName": "10 Stammdaten/Energieausweis",
    "additionalTagName": "",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "acMaintenanceContract",
    "documentLabelDE": "Klimaanlage",
    "additionalDocumentLabel": "",
    "tagCode": "VENTILATION_AND_AIR_CONDITIONING",
    "tagName": "30 Versorger/Lüftung+Klima",
    "additionalTagName": "30 Versorger/Klimaanlage",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "tvContract",
    "documentLabelDE": "Kabel TV",
    "additionalDocumentLabel": "",
    "tagCode": "TELCO_AND_MULTIMEDIA",
    "tagName": "30 Versorger/Telko+Multimedia",
    "additionalTagName": "30 Versorger/Kabel TV",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "internetContract",
    "documentLabelDE": "Internet",
    "additionalDocumentLabel": "",
    "tagCode": "TELCO_AND_MULTIMEDIA",
    "tagName": "30 Versorger/Telko+Multimedia",
    "additionalTagName": "30 Versorger/Internet",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "legionnairesReport",
    "documentLabelDE": "Prüfbericht",
    "additionalDocumentLabel": "legionnaireLastReport",
    "tagCode": "MAINTENANCE_REPORT",
    "tagName": "50 Objektreporting/Wartungsbericht",
    "additionalTagName": "50 Objektreporting/LegionellenPrüfbericht",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "legionnairesHazard",
    "documentLabelDE": "Gefährdungsanalyse",
    "additionalDocumentLabel": "legionnaireHazardAnalysis",
    "tagCode": "DRINKING_WATER_ANALYSIS",
    "tagName": "50 Objektreporting/Trinkwasseruntersuchung",
    "additionalTagName": "",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "legionnairesContract",
    "documentLabelDE": "Prüfinstitut",
    "additionalDocumentLabel": "legionnaireCompanyContract",
    "tagCode": "DRINKING_WATER_SAMPLING",
    "tagName": "30 Versorger/Trinkwasserbeprobung",
    "additionalTagName": "",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "detector",
    "documentLabelDE": "Rauchwarnmelder",
    "additionalDocumentLabel": "Wartungsvertrag",
    "tagCode": "SMOKE_DETECTOR",
    "tagName": "30 Versorger/Rauchwarnmelder",
    "additionalTagName": "",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "fireExtinguisher",
    "documentLabelDE": "Feuerlöscher",
    "additionalDocumentLabel": "",
    "tagCode": "FIRE_PROTECTION",
    "tagName": "30 Versorger/Brandschutz",
    "additionalTagName": "30 Versorger/Feuerlöscher",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "watertreatment",
    "documentLabelDE": "Wasseraufbereitung",
    "additionalDocumentLabel": "",
    "tagCode": "HEATING_SANITARY",
    "tagName": "30 Versorger/Heizung+Sanitär",
    "additionalTagName": "30 Versorger/Wasseraufbereitung",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "smokeextraction",
    "documentLabelDE": "Rauchabzugsanlage",
    "additionalDocumentLabel": "",
    "tagCode": "FIRE_PROTECTION",
    "tagName": "30 Versorger/Brandschutz",
    "additionalTagName": "30 Versorger/Rauchabzugsanlage",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "ventilation",
    "documentLabelDE": "Lüftungsanlage",
    "additionalDocumentLabel": "",
    "tagCode": "VENTILATION_AND_AIR_CONDITIONING",
    "tagName": "30 Versorger/Lüftung+Klima",
    "additionalTagName": "30 Versorger/Lüftungsanlage",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "garageDoor",
    "documentLabelDE": "TG-Tor",
    "additionalDocumentLabel": "",
    "tagCode": "GARAGE",
    "tagName": "30 Versorger/Garage",
    "additionalTagName": "",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "elevator",
    "documentLabelDE": "Aufzug",
    "additionalDocumentLabel": "",
    "tagCode": "MAINTENANCE_REPORT",
    "tagName": "50 Objektreporting/Wartungsbericht",
    "additionalTagName": "50 Objektreporting/Aufzug",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  }
]

  window.allowedPropertyDocumentTagCodes = [
  "BILLING_KEY",
  "ACCEPTANCE_OF_COMMON_PROPERTY",
  "FORM",
  "BUILDING_ACCEPTANCE_AND_INSTALLATION",
  "BUILDING_DESCRIPTION",
  "BUILDING_PERMIT_AND_NOTIFICATIONS",
  "FIRE_PROTECTION_CONCEPT",
  "MONUMENT_PROTECTION",
  "ENERGY_CERTIFICATE",
  "LEASEHOLD",
  "CONSERVATION_STATUTE",
  "CREDITOR_ID",
  "LAND_REGISTER",
  "PROPERTY_TAX",
  "HOUSE_RULE",
  "CUSTOMER_MASTER_DATA",
  "PROPERTY_PHOTOS",
  "PROPERTY_CONTRACTS",
  "PLANS",
  "LOCKING_SYSTEM",
  "TECHNICAL_DOCUMENTS",
  "DECLARATION_OF_DIVISION",
  "ADMINISTRATOR_AGREEMENT",
  "ADVISORY_BOARD_INSURANCE",
  "LIABILITY_INSURANCE",
  "OTHER_INSURANCES",
  "HOMEOWNERS_INSURANCE",
  "CORRESPONDENCE_WITH_INSURANCE",
  "SEWAGE",
  "ELEVATOR",
  "BANK",
  "OUTDOOR_FACILITIES",
  "GARAGE",
  "GAS_HEATING_OIL",
  "HEATING_SANITARY",
  "DRINKING_WATER_SAMPLING",
  "VENTILATION_AND_AIR_CONDITIONING",
  "METERING_SERVICE_PROVIDERS",
  "GARBAGE",
  "SMOKE_DETECTOR",
  "ELECTRICAL_INSTALLATIONS",
  "FIRE_PROTECTION",
  "STREET_CLEANING",
  "ELECTRICITY",
  "TELCO_AND_MULTIMEDIA",
  "WASHER_AND_DRYER",
  "WATER",
  "ROOF",
  "TAX_AUDIT",
  "PERSONNEL_FILE",
  "CONTRACT",
  "CORRESPONDENCE_BUILDING_SERVICE",
  "HOUSE_NOTICE",
  "CARETAKER_LOG",
  "PROPERTY_INSPECTION",
  "ELEVATOR_REPORT",
  "DRINKING_WATER_ANALYSIS",
  "MAINTENANCE_REPORT",
  "METER_READING",
  "RESOLUTIONS_COLLECTION",
  "ASSEMBLY",
  "SESSIONS",
  "PROTOCOL",
  "SALES_CONTRACT",
  "MASTER_DATA",
  "TENANT_CONTRACT",
  "SEPA_MANDATES",
  "OWNER_CORRESPONDENCE",
  "TENANT_CORRESPONDENCE",
  "USER_CHANGE",
  "ACCOUNTING_ARCHIVE",
  "BOOKING_JOURNAL",
  "GUARANTEE",
  "ANNUAL_SETTLEMENT",
  "BANK_ORDER",
  "SPECIAL_CONTRIBUTION",
  "STATEMENT_OF_ACCOUNT",
  "INVOICE",
  "ECONOMIC_PLAN",
  "PROJECT",
  "PROJECT_ARCHIVE"
]
})()
